var render = function render(_c,_vm){return _c('p',{staticStyle:{"display":"inline","flex-wrap":"wrap","min-height":"25px","line-height":"22px"},domProps:{"innerHTML":_vm._s(_vm.$options.html(_vm.props, _vm))},on:{"copy":_vm.$options.onCopy}})
}
var staticRenderFns = []

export { render, staticRenderFns }